import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const contenedor = document.getElementById("root");
const root = createRoot(contenedor);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
